






import { Vue, Component } from 'vue-property-decorator';
import ViewUser from '@/components/UserComponents/ViewUserProfile.vue';

@Component({
  components: {
    ViewUser,
  },
})
export default class UserProfile extends Vue {
  mounted() {
    this.$store.dispatch('findUserProfile', this.$route.params.id);
  }
}
